const KeyCodes = {
  KEY_ENTER: 13
};

module.exports = {
  KeyCodes
};
